import * as React from "react";

const SvgComponent = (props) => (
    <svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.0781 4H15.0781V19H20.0781V4Z" fill="#27911B" />
        <path d="M0.078125 19L14.0781 22.75V0.25L0.078125 4V19ZM3.57812 6.5H5.80313L7.05313 9.275L8.35312 6.5H10.5281L8.25313 10.475L10.7531 15.15H8.52812L7.05313 11.85L5.60312 15.15H3.42812L5.85312 10.55L3.57812 6.5Z" fill="#27911B" />
    </svg>

);

export default SvgComponent;
